import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@saviynt/design-system';

import {
  SCREEN_SIZE_MOBILE_XLARGE,
  SCREEN_WIDTH_QUERIES,
} from '../../../utils/constant';
import DynamicSort from '../ViewControls/DynamicSort';
import CertListExport from '../ViewControls/Export';
import RefreshProgressButton from '../ViewControls/RefreshProgressButton';
import RoleFilter from '../ViewControls/RoleFilter';
import SearchBar from '../ViewControls/SearchBar';

import './CertsListHeaderControls.css';

function CertsListHeaderControls() {
  const [isSearchBarExpanded, setIsSearchBarExpanded] = useState(false);
  const {
    core: { isAdminLogin },
    global: { mediaQueryValue },
  } = useSelector((state) => state?.certifications?.list);

  // Responsive selector queries
  const mobileXlargeQuery = SCREEN_WIDTH_QUERIES.find(
    (item) => item.label === SCREEN_SIZE_MOBILE_XLARGE
  );
  const isMobileXlargeWidth = mobileXlargeQuery.value <= mediaQueryValue;

  return (
    <Box className='CertsListHeaderControls'>
      <SearchBar
        isSearchBarExpanded={isSearchBarExpanded}
        setIsSearchBarExpanded={setIsSearchBarExpanded}
      />
      <DynamicSort />
      <RefreshProgressButton />
      {isAdminLogin && (
        <RoleFilter
          isMobileXlargeWidth={isMobileXlargeWidth}
          isSearchBarExpanded={isSearchBarExpanded}
        />
      )}
      {!isMobileXlargeWidth && <CertListExport />}
    </Box>
  );
}

export default CertsListHeaderControls;
